import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=4dd3ffc7"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=4dd3ffc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports